import { connect } from 'react-redux';
import { makeStyles, tokens } from '@fluentui/react-components';
import { AppState } from '../../../../redux/reducers';
import { QueueDisplayScreen, Sector, Sede } from '../../../../models/Entities/Turnero';
import { ErrorType } from '../../../../models/HttpError';
import * as QueueDisplayStore from '../../../../redux/middleware/Turnero/Turnero.QueueDisplayScreen.Middleware';
import * as SectoresStore from '../../../../redux/middleware/Turnero/Turnero.Sectores.Middleware';
import * as SedesStore from '../../../../redux/middleware/Turnero/Turnero.Sedes.Middleware';

export interface OwnProps {
  isOpen: boolean;
  onClose: () => void;
  displayId?: number;
  defaultSectorId?: number;
  defaultSedeId?: number;
}

interface StateProps {
  isSaving: boolean;
  isSaved: boolean | undefined;
  failOnSaving: boolean;
  error: ErrorType | undefined;
  currentDisplay?: QueueDisplayScreen;
  sectores: Sector[];
  sedes: Sede[];
  isLoadingSectores: boolean;
  isLoadingSedes: boolean;
}

interface DispatchProps {
  CreateQueueDisplayScreen: typeof QueueDisplayStore.actionCreators.CreateQueueDisplayScreen;
  UpdateQueueDisplayScreen: typeof QueueDisplayStore.actionCreators.UpdateQueueDisplayScreen;
  GetQueueDisplayScreens: typeof QueueDisplayStore.actionCreators.GetQueueDisplayScreens;
  GetSectores: typeof SectoresStore.actionCreators.GetSectores;
  GetSedes: typeof SedesStore.actionCreators.GetSedes;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = (state: AppState, own: OwnProps): StateProps => {
  const currentDisplay = own.displayId
    ? (state.Turnero?.QueueDisplayScreen?.list || []).find((d) => d.id === own.displayId)
    : undefined;

  const isAdding = state.Turnero?.QueueDisplayScreen?.isAddingNewOne || false;
  const isUpdating = state.Turnero?.QueueDisplayScreen?.isUpdatingOne || false;
  const isSavedAdd = state.Turnero?.QueueDisplayScreen?.successAddingNewOne;
  const isSavedUpdate = state.Turnero?.QueueDisplayScreen?.successUpdatingOne;
  const failAdd = state.Turnero?.QueueDisplayScreen?.failOnAddingNewOne || false;
  const failUpdate = state.Turnero?.QueueDisplayScreen?.failOnUpdatingOne || false;

  return {
    isSaving: isAdding || isUpdating,
    isSaved: own.displayId ? isSavedUpdate : isSavedAdd,
    failOnSaving: own.displayId ? failUpdate : failAdd,
    error: state.Turnero?.QueueDisplayScreen?.error,
    currentDisplay,
    sectores: state.Turnero?.Sectores?.list || [],
    sedes: state.Turnero?.Sedes?.list || [],
    isLoadingSectores: state.Turnero?.Sectores?.isLoadingAll || false,
    isLoadingSedes: state.Turnero?.Sedes?.isLoadingAll || false,
  };
};

export const mapDispatchToProps = {
  CreateQueueDisplayScreen: QueueDisplayStore.actionCreators.CreateQueueDisplayScreen,
  UpdateQueueDisplayScreen: QueueDisplayStore.actionCreators.UpdateQueueDisplayScreen,
  GetQueueDisplayScreens: QueueDisplayStore.actionCreators.GetQueueDisplayScreens,
  GetSectores: SectoresStore.actionCreators.GetSectores,
  GetSedes: SedesStore.actionCreators.GetSedes,
};

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: tokens.spacingHorizontalS,
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
});

export const connector = connect(mapStateToProps, mapDispatchToProps);
